import React, { useState, useEffect, useMemo } from "react";
import { observer } from "mobx-react";
import HeaderLayout from "Components/LoggedInLayout/HeaderLayout";
import ReportsBody from "Pages/Dashboard/reports_v2/ReportsBody";
import reportsStore from "Pages/Dashboard/reports_v2/reportsStore";
import DateUtils from "Utils/DateUtils";
import { useHistory } from "react-router-dom";
import { useCopilotContext } from "Pages/Dashboard/Copilot/agent/copilotContext";
import usePageFindings from "Pages/Dashboard/Copilot/agent/usePageFindings";
import reportsFindings from "./reportsFindings";
import copilotStore from "Stores/copilotStore";
import copilotDrawerStore from "Stores/copilotDrawerStore";

const defaultBreadcrumbValue = [{ name: "Reports", link: "/reports" }];

const ReportsModulev2 = observer(() => {
  const [breadcrumbArr, setBreadCrumbArr] = useState([
    ...defaultBreadcrumbValue
  ]);

  const history = useHistory();
  const { fromDate = 0, toDate = 0 } = reportsStore.dateFilter || {};
  const rangeDays = fromDate && toDate
    ? Math.round((toDate - fromDate) / (24 * 60 * 60 * 1000))
    : 0;

  useCopilotContext("reports", () => ({
    viewState: {
      tab: reportsStore.tabType,
      range: reportsStore.dateFilter,
      members: reportsStore.memberIds
    }
  }));

  const copilotFindings = useMemo(
    () =>
      reportsFindings({
        rangeDays,
        tab: reportsStore.tabType,
        totals: reportsStore.tabType === "sequence" ? reportsStore.sequenceAnalyticsData : undefined,
        rows: reportsStore.tabType === "sequence" ? reportsStore.reportsData : [],
        actions: {
          widen: () => {
            reportsStore.setActiveDateFilter("month");
            reportsStore.setDateFilter(DateUtils.getMonthTimeStamp());
          },
          explainChange: () => {
            copilotStore.setComposerDraft("Why did ");
            copilotDrawerStore.openFor("reports", "");
          },
          weeklyDigest: () => {
            copilotStore.setPendingAutoSend(
              `Write a five-line weekly digest of the ${reportsStore.tabType} report for the current date range: what improved, what dropped, and the one thing to fix. Plain text.`
            );
            copilotDrawerStore.openFor("reports", "");
          },
          showBestSequence: row => {
            if (row?.id) {
              history.push(`/sequences/all/${row.id}`);
            } else {
              reportsStore.setTabType("sequence");
            }
          },
          weakestCopy: () => {
            copilotStore.setPendingAutoSend(
              "Across my sequences this period, which email copy is weakest by reply rate relative to opens? Name the step and suggest a rewrite. Do not change anything."
            );
            copilotDrawerStore.openFor("reports", "");
          },
          showBounceSources: () => reportsStore.setTabType("sequence"),
          openSequence: row => row?.id && history.push(`/sequences/all/${row.id}`)
        }
      }),
    [rangeDays, reportsStore.tabType, reportsStore.sequenceAnalyticsData, reportsStore.reportsData]
  );
  usePageFindings(copilotFindings, "reports");

  return (
    <div className="reportsPage pageClass">
      <HeaderLayout className="reports" breadcrumbArr={breadcrumbArr} />
      <ReportsBody />
    </div>
  );
});

export default ReportsModulev2;
export { ReportsModulev2 };
